/** @module Camunda/ProcessActivityItem */
define([
    "dojo/_base/declare",
    "dijit/_TemplatedMixin",
    "dijit/_WidgetBase",
    "dijit/_WidgetsInTemplateMixin",
    "csi/html",
    "csi/types",
    "dojo/text!./ProcessActivityItem.html",
    
    "csi/widget/MaterialIconWithLabel"
], function (declare, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, html, types, template) {

    const ELEMENT_ID_ATTR_ID = "data-csi-element-id";

    var _Widget = declare([_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin], {
        templateString: template,

        // extension points
        itemNode: null,
        textNode: null,
        commentContainerNode: null,
        commentNode: null,
        timeNode: null,

        /** @property {string} elementId */
        elementId: "",

        /** @property {string} text */
        text: "",

        /** @property {string} comment */
        comment: "",

        /** @property {number} time */
        time: "",

        /** @property {string} timeFormat - format to use to render time */
        timeFormat: types.FORMAT_DIFF,

        _setElementIdAttr: { node: "itemNode", type: "attribute", attribute: ELEMENT_ID_ATTR_ID },

        /**
         * Render text
         * @param {string} value
         */
        _setTextAttr: function (value) {
            this._set("text", value);
            html.richText(value, this.textNode);
        },

        /**
         * Render comment
         * @param {string} value
         */
        _setCommentAttr: function (value) {
            this._set("comment", value);
            html.clear(this.commentNode);
            html.text(this.commentNode, value);
            html.setVisible(this.commentContainerNode, Boolean(value));
        },

        /**
         * Render time
         * @param {string} value
         */
        _setTimeAttr: function (value) {
            this._set("time", value);
            html.clear(this.timeNode);
            html.text(this.timeNode, types.formatTime(value, this.timeFormat));
        },
    });

    // specify properties of widget that can be used for csi/widget/Container
    _Widget.widgetProperties = ["elementId", "text", "comment", "time"];

    _Widget.ELEMENT_ID_ATTR_ID = ELEMENT_ID_ATTR_ID;

    return _Widget;
});
